export enum DragTypes {
  DEVELOPMENT_ITEM_CARD = "DEVELOPMENT_ITEM_CARD",
}
